class LogoComponent {
    constructor(blockElement, logoCount, logoUrls) {
        this.logoCount = logoCount;
        this.blockElement = blockElement;
        this.switchIndex = 0;
        this.switchIncrement = 1;
        this.logoUrlIndex = logoCount;
        this.logoUrls = logoUrls.split(',');
        this.numberOfLogoUrls = this.logoUrls.length;

        this.viewportWidth = this.getViewportWidth();

        setInterval(() => this.switchLogo(), 3000);
    }

    getViewportWidth() {
        return document.documentElement.clientWidth;
    }

    switchLogo() {
        let nextLogoUrl = this.logoUrls[this.logoUrls.length - 1];
        if (this.logoUrlIndex >= 0 && this.logoUrlIndex < this.logoUrls.length) {
            nextLogoUrl = this.logoUrls[this.logoUrlIndex];
        }

        const li = this.blockElement.querySelector(`li[data-index="${this.switchIndex}"`);
        const activeLogo = li.querySelector('.logo.active');
        const inactiveLogo = li.querySelector('.logo:not(.active)');

        // Set src desktop
        const inactiveLogoImage = inactiveLogo.querySelector('img');
        inactiveLogoImage.src = nextLogoUrl;

        // Set src mobile
        const inactiveLogoPictureSource = inactiveLogo.querySelector('picture source');
        inactiveLogoPictureSource.srcset = nextLogoUrl;

        if (activeLogo) {
            activeLogo.classList.remove('active');
        }
        if (inactiveLogo) {
            inactiveLogo.classList.add('active');
        }

        this.switchIndex += this.switchIncrement;
        if (this.switchIndex >= this.logoCount) {
            this.switchIndex -= this.logoCount;
        }

        // Next time, next logo
        this.logoUrlIndex += 1;
        if (this.logoUrlIndex >= this.numberOfLogoUrls) {
            this.logoUrlIndex = 0;
        }
    }
}

class ClientLogos {
    constructor() {
        const logosBlockElements = document.querySelectorAll('.logos');

        if (logosBlockElements.length < 1) {
            return;
        }

        logosBlockElements.forEach((element, index) => {
            element.classList.add(`logos-${index}`);
            const logoURLs = element.dataset.logoUrls;
            const switchingEnabled = element.dataset.switchingEnabled;
            if (switchingEnabled == 'false') {
                return;
            }

            let logoCount = element.dataset.logoCountDesktop;
            if (this.viewportWidth <= 600) {
                logoCount = element.dataset.logoCountMobile;
            }

            new LogoComponent(element, logoCount, logoURLs);
        });
    }
}
new ClientLogos();
